import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { Toaster } from './components/ui/sonner.tsx';
import Auth0ProviderWithHistory from './components/auth/Auth0ProviderWithHistory.tsx';

import './components/charts/echartsConfig.ts';

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<Auth0ProviderWithHistory>
			<App />
			<Toaster />
		</Auth0ProviderWithHistory>
	</StrictMode>
);
